import { render, staticRenderFns } from "./ProjectGroupDetailsTopInfo.vue?vue&type=template&id=718072af&"
import script from "./ProjectGroupDetailsTopInfo.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupDetailsTopInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports